<template>
    <div style="height: calc(100% - 44px);">
        <div>
            <el-tree default-expand-all ref="tree" v-loading="treeLoading" node-key="value" :highlight-current="true" :data="myOptions" @node-click="handleNodeClick">
                <span class="lr-tree-node"  slot-scope="{ node }">
                    <i class="el-icon-notebook-2"></i>
                    {{ node.label }}
                </span>
            </el-tree> 
        </div>
      <el-button
        title="复制"
        @click.stop="handleWidgetClone(index)"
        class="drag-table-action-clone"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="primary"
      >
        <i class="el-icon-copy-document"></i>
      </el-button>
      <el-button
        title="删除"
        @click.stop="handleWidgetDelete(index)"
        class="drag-table-action-delete"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="danger"
      >
        <i class="el-icon-delete"></i>
      </el-button>
    </div>
  </template>
  <script>
  import mixin from "./mixin";
    import newmixin from '../../mixin'

  export default {
    name: "drag-form-tree",
    mixins: [mixin(),newmixin()],
    props: {
        data: {
            type: Object,
            default: () => {
            return {}
            }
        },
    },
    data() {
      return {
        form: {},
      };
    },
    computed: {
      topComponents() {
        return this.myComponent.topComponents;
      },
      centerComponents() {
        return this.myComponent.centerComponents;
      },
      bottomComponents() {
        return this.myComponent.bottomComponents;
      },
      calcHeight(){
        return `calc(100%)`
      },
    },
    methods: {
        handleNodeClick(){

        },
      handleWidgetClone(index) {
        let cloneData = this.$deepClone(this.myComponent);
        cloneData.prop = Date.now() + "_" + Math.ceil(Math.random() * 99999);
        cloneData.table = "";
        cloneData.field = "";
        this.setAllProp(cloneData.children);
        this.parentComponents.splice(index, 0, cloneData);
        this.$nextTick(() => {
          this.handleSelectWidget(index + 1);
          this.$emit("change");
        });
      },
      handleFormClickAdd(item) {
        console.log(item);
        console.log(this.myComponent);
        // this.childrenComponents.push(item);
        // this.$refs.dragFormWraper.handleFormAdd(
        //   { newIndex: this.childrenComponents.length - 1 },
        //   true
        // );
      },
    },
  };
  </script>
  